import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let bannerHome = new Swiper(".banner__home", {
        watchOverflow: true,
        navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });

    let eventsList = new Swiper(".events__list", {
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 32,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".events-button-next",
            prevEl: ".events-button-prev",
        },
    });
    let partnersList = new Swiper(".partners__list", {
        watchOverflow: true,
        slidesPerView: 5,
        spaceBetween: 32,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".partners-button-next",
            prevEl: ".partners-button-prev",
        },
    });
    let bannerContents = new Swiper(".banner__contents", {
        watchOverflow: true,
        navigation: {
            nextEl: '.contents-button-next',
            prevEl: '.contents-button-prev',
        },
    });
};
